<template>
  <div v-if="is_load" class="membership_sms_width">
    <div style="width: 1000px;">
      <v-row class="mt-10">
        <v-col class="pt-0 pb-0">
          <p class="mt-5 mb-0 title font-weight-light font-weight-bold">
            SMS 발송 설정
          </p>
        </v-col>
      </v-row>
      <v-row cols="12">
        <v-col class="pt-5 pb-0 col-4">
          <v-select
            v-model="send_number"
            :items="send_number_items"
            item-text="sender_number"
            item-value="sender_no"
            placeholder="발신번호 선택"
            label="발신번호 선택"
            class="pt-0 body-2"
            dense
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col class="pt-5 pb-0 col-4">
          <v-select
            v-model="exclude_unsubscriber"
            :items="exclude_unsubscriber_items"
            placeholder="수신거부자 발송 여부 선택"
            label="수신거부자 발송 여부 선택"
            class="pt-0 body-2"
            dense
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col class="pt-5 pb-0 col-4">
          <v-select
            v-model="sms_type"
            :items="sms_type_items"
            item-text="text"
            item-value="value"
            placeholder="90byte 초과시 단문/장문 발송 선택"
            label="90byte 초과시 단문/장문 발송 선택"
            class="pt-0 body-2"
            dense
            outlined
            @change="byteTypeChagne()"
            hide-details
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mt-10">
        <v-col class="pt-0 pb-0">
          <p class="mt-5 mb-0 title font-weight-light font-weight-bold">
            멤버십 SMS 알림 내역 설정
          </p>
        </v-col>
      </v-row>

      <v-row class="pt-5">
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text"
            >* 멤버십 기간 만료 전 알림 (정기결제 회원 발송)</font
          >
        </v-col>
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text"
            >* 멤버십 기간 만료 전 알림 (1회결제 회원 발송)</font
          >
        </v-col>
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text"
            >* 멤버십 기간 만료 후 알림 (1회결제 회원 발송)</font
          >
        </v-col>
      </v-row>

      <v-row class="pt-4" cols="12" style="height: 50px;">
        <v-col class="pt-0 pb-0 col-4">
          <v-select
            v-model="before_recurring_expired.sub_days"
            :items="send_day_items"
            item-text="text"
            item-value="value"
            placeholder="만료 3일전 발송"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:135px;"
          ></v-select>

          <v-select
            v-model="before_recurring_expired.send_time_hour"
            :items="hour_items"
            placeholder="시간"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
          <v-select
            v-model="before_recurring_expired.send_time_minute"
            :items="minute_items"
            placeholder="분"
            persistent-hint
            class="pt-0 body-2"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 col-4">
          <v-select
            v-model="before_one_time_expired.sub_days"
            :items="send_day_items"
            placeholder="만료 3일전 발송"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:135px;"
          ></v-select>
          <v-select
            v-model="before_one_time_expired.send_time_hour"
            :items="hour_items"
            placeholder="시간"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
          <v-select
            v-model="before_one_time_expired.send_time_minute"
            :items="minute_items"
            placeholder="분"
            persistent-hint
            class="pt-0 body-2"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 col-4">
          <v-select
            v-model="after_expired.sub_days"
            :items="expiration_day_items"
            placeholder="만료 3일전 발송"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:135px;"
          ></v-select>
          <v-select
            v-model="after_expired.send_time_hour"
            :items="hour_items"
            placeholder="시간"
            persistent-hint
            class="pt-0 body-2 float-left mr-1"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
          <v-select
            v-model="after_expired.send_time_minute"
            :items="minute_items"
            placeholder="분"
            persistent-hint
            class="pt-0 body-2"
            outlined
            dense
            style="width:87px"
            disabled
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-textarea
            v-model="before_recurring_expired.message"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>
          <v-card
            class="mt-1"
            outlined
            style="height: 50px; border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="beforeRecurringExpiredStatus()"
                      v-model="before_recurring_expired.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        before_recurring_expired.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(
                          this.before_recurring_expired.message
                        ) + this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col>
          <v-textarea
            v-model="before_one_time_expired.message"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>
          <v-card
            class="mt-1"
            outlined
            style="height: 50px;  border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="beforeOneTimeExpired()"
                      v-model="before_one_time_expired.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        before_one_time_expired.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(
                          this.before_one_time_expired.message
                        ) + this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col>
          <v-textarea
            v-model="after_expired.message"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>
          <v-card
            class="mt-1"
            outlined
            style="height: 50px;  border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="afterExpired()"
                      v-model="after_expired.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        after_expired.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(this.after_expired.message) +
                          this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <!-- -->
      <v-row class="pt-2">
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text"
            >* 멤버십 적립금 지급 알림 (적립금 혜택 사용시)</font
          >
        </v-col>
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text float-left"
            >* 멤버십 쿠폰 지급 알림 (쿠폰 혜택 사용시)</font
          >
          <template>
            <div class="text-center float-left">
              <div style="display: flex;">
                <v-tooltip v-model="tooltip_show" bottom>
                  <template v-slot:activator="{ attrs }">
                    <v-icon
                      v-bind="attrs"
                      class="ml-2"
                      @click="tooltip_show = !tooltip_show"
                      color="#8C8C8C"
                      size="18"
                      >mdi-alert-circle</v-icon
                    >
                  </template>
                  <div>
                    <p class="text-left">
                      [카페24 어드민 > 고객관리 > 자동 발송 메시지 설정 > 광고
                      관련 메시지]
                    </p>
                    <p class="text-left mb-0">
                      메뉴에서 쿠폰발급 안내를 사용하신 경우에는
                    </p>
                    <p class="text-left mb-0">
                      사용을 하지 않는것을 추천드립니다.
                    </p>
                    <p class="text-left mb-0">
                      * 쿠폰 관련 SMS가 이중으로 발송되오니 참고하여
                      사용해주세요
                    </p>
                  </div>
                </v-tooltip>
              </div>
            </div>
          </template>
        </v-col>
        <v-col class="pt-0 pb-0">
          <font class="font-weight-bold body-2 black--text"
            >* 멤버십 해지 완료시 알림</font
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
            v-model="issued_point.message"
            counter
            :counter-value="pointAlarmSize"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>

          <v-card
            class="mt-1"
            outlined
            style="height: 50px;  border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="pointMessage()"
                      v-model="issued_point.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        issued_point.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(this.issued_point.message) +
                          this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col>
          <v-textarea
            v-model="issued_coupon.message"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>
          <v-card
            class="mt-1"
            outlined
            style="height: 50px; border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="orderedMessage()"
                      v-model="issued_coupon.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        issued_coupon.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(this.issued_coupon.message) +
                          this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col>
          <v-textarea
            v-model="expired.message"
            outlined
            no-resize
            style="font-size:13px;"
            class="smsInfo"
            hide-details
          ></v-textarea>
          <v-card
            class="mt-1"
            outlined
            style="height: 50px; border-color: rgba(0, 0, 0, 0.38);"
          >
            <v-list-item>
              <v-list-item-content>
                <div>
                  <div class="float-left d-flex align-center">
                    <v-switch
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0 pt-0"
                      value="enabled"
                      @change="expiredMessage()"
                      v-model="expired.message_status"
                    ></v-switch>
                    <p class="black--text mb-0" style="font-size: 12px;">
                      {{
                        expired.message_status == "enabled"
                          ? "사용함"
                          : "사용안함"
                      }}
                    </p>
                  </div>

                  <div class="float-right" style="margin-top:6px;">
                    <p class="mb-0 float-right" style="font-size: 12px;">
                      {{
                        this.textCounterValue(this.expired.message) +
                          this.byteType
                      }}
                    </p>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <div class="mt-8 mb-8 d-flex float-right">
        <v-btn
          color="primary"
          width="250"
          depressed
          @click="smsAlarmSettingSave()"
          >설정내역 저장</v-btn
        >
      </div>
    </div>
  </div>
</template>
<style>
.smsInfo textarea {
  line-height: 1.6 !important;
  height: 200px;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Common from "@/libs/common.js";

export default {
  data() {
    return {
      M,
      // 멤버십 기간 만료 전 알림 (정기결제 회원 발송)
      periodic_payment_day: { text: "만료 3일 전 발송", value: 3 },
      periodic_payment_hour: "",
      periodic_payment_minute: "",
      // 멤버십 기간 만료 전 알림 (1회결제 회원 발송)
      one_payment_day: { text: "만료 3일 전 발송", value: 3 },
      one_payment_hour: "",
      one_payment_minute: "",
      // 멤버십 기간 만료 후 알림 (1회결제 회원 발송)
      one_expiration_day: { text: "기간만료 1일 후 발송", value: 1 },

      send_day_items: [
        { text: "만료 5일 전 발송", value: 5 },
        { text: "만료 4일 전 발송", value: 4 },
        { text: "만료 3일 전 발송", value: 3 },
        { text: "만료 2일 전 발송", value: 2 },
        { text: "만료 1일 전 발송", value: 1 },
      ],
      expiration_day_items: [
        { text: "기간 만료 1일 후 발송", value: 1 },
        { text: "기간 만료 2일 후 발송", value: 2 },
        { text: "기간 만료 3일 후 발송", value: 3 },
        { text: "기간 만료 4일 후 발송", value: 4 },
        { text: "기간 만료 5일 후 발송", value: 5 },
      ],
      exclude_unsubscriber_items: [
        { text: "발송함", value: "F" },
        { text: "발송안함", value: "T" },
      ],
      sms_type_items: [
        { text: "SMS 단문 (90 byte 초과시 여러개 발송)", value: "sms" },
        { text: "LMS 장문 (2000 byte까지 한번에 발송)", value: "lms" },
      ],
      hour_model: "",
      hour_items: [
        { text: "00시", value: "00" },
        { text: "01시", value: "01" },
        { text: "02시", value: "02" },
        { text: "03시", value: "03" },
        { text: "04시", value: "04" },
        { text: "05시", value: "05" },
        { text: "06시", value: "06" },
        { text: "07시", value: "07" },
        { text: "08시", value: "08" },
        { text: "09시", value: "09" },
        { text: "10시", value: "10" },
        { text: "11시", value: "11" },
        { text: "12시", value: "12" },
        { text: "13시", value: "13" },
        { text: "14시", value: "14" },
        { text: "15시", value: "15" },
        { text: "16시", value: "16" },
        { text: "17시", value: "17" },
        { text: "18시", value: "18" },
        { text: "19시", value: "19" },
        { text: "20시", value: "20" },
        { text: "21시", value: "21" },
        { text: "22시", value: "22" },
        { text: "23시", value: "23" },
      ],
      minute_model: 0,
      minute_items: [
        { text: "00분", value: "00" },
        { text: "30분", value: "30" },
      ],
      expiration_befor_alarm_period:
        "[[쇼핑몰이름]][NAME]님\n[DATE]에 [[멤버십상품명]] [PRICE]원 결제 예정입니다.\n감사합니다",
      expiration_befor_alarm_one:
        "[[쇼핑몰이름]][NAME]님\n현재 [[멤버십상품명]]이 00일 후 만료예정입니다.\n멤버십을 연장하여 혜택을 받으세요.\n감사합니다",
      expiration_after_alarm_one:
        "[[쇼핑몰이름]][NAME]님\n현재 [[멤버십상품명]]이 만료되었습니다.\n멤버십을 연장하여 혜택을 받으세요.\n감사합니다. ",
      point_alarm:
        "[[쇼핑몰이름]][NAME]님\n[[멤버십상품명]] : 적립금 [PRICE]\n적립금이 지급되었습니다.\n감사합니다.",
      product_buy_alarm:
        "[[쇼핑몰이름]][NAME]님\n[[멤버십상품명]] : [쿠폰명]\n쿠폰이 지급되었습니다.\n감사합니다.",
      close_alarm:
        "[[쇼핑몰이름]][NAME]님\n[[멤버십상품명]]이 해지완료되었습니다.\n감사합니다",
      byteType: " / 90byte",
      sms_type: "sms",
      send_number: "",
      send_number_items: [],
      exclude_unsubscriber: "send",
      before_recurring_expired: {
        sub_days: "",
        send_time: "",
        message: "",
        status: "",
      },
      //멤버십 기간 만료 전 알림 (1회결제 회원 발송)
      before_one_time_expired: {
        sub_days: "",
        send_time: "",
        message: "",
        status: "",
      },
      //멤버십 기간 만료 후 알림 (1회결제 회원 발송)
      after_expired: {
        sub_days: "",
        send_time: "",
        message: "",
        status: "",
      },
      //멤버십 적립금 지급 알림 (적립금 혜택 사용시)
      issued_point: {
        message: "",
        message_status: "",
      },
      //멤버십 상품 결제 완료시 알림
      issued_coupon: {
        message: "",
        message_status: "",
      },
      //멤버십 해지 완료시 알림
      expired: {
        message: "",
        message_status: "",
      },

      is_load: false,
      tooltip_show: false,
    };
  },
  methods: {
    textCounterValue: function(str) {
      var utf8length = 0;
      for (var n = 0; n < str.length; n++) {
        var c = str.charCodeAt(n);
        if (c < 128) {
          utf8length++;
        } else if (c > 127 && c < 2048) {
          utf8length = utf8length + 2;
        } else {
          utf8length = utf8length + 3;
        }
      }
      return utf8length + " byte";
    },
    expirationBeforAlarmPeriodSize: function() {
      return (
        this.textCounterValue(this.before_recurring_expired.message) +
        this.byteType
      );
    },
    expirationBeforAlarmOneSize: function() {
      return (
        this.textCounterValue(this.before_one_time_expired.message) +
        this.byteType
      );
    },
    expirationAfterAlarmOneSize: function() {
      return this.textCounterValue(this.after_expired.message) + this.byteType;
    },
    pointAlarmSize: function() {
      return this.textCounterValue(this.issued_point.message) + this.byteType;
    },
    productBuyAlarmSize: function() {
      return this.textCounterValue(this.issued_coupon.message) + this.byteType;
    },
    closeAlarmSize: function() {
      return this.textCounterValue(this.expired.message) + this.byteType;
    },
    byteTypeChagne: function() {
      if (this.sms_type == "sms") {
        this.byteType = " / 90byte";
      } else {
        this.byteType = " / 2000byte";
      }
    },
    smsAlarmSettingSave: async function() {
      if (
        this.before_recurring_expired.send_time_hour &&
        this.before_recurring_expired.send_time_minute
      ) {
        this.before_recurring_expired.send_time =
          this.before_recurring_expired.send_time_hour +
          ":" +
          this.before_recurring_expired.send_time_minute;
      }

      if (
        this.before_one_time_expired.send_time_hour &&
        this.before_one_time_expired.send_time_minute
      ) {
        this.before_one_time_expired.send_time =
          this.before_one_time_expired.send_time_hour +
          ":" +
          this.before_one_time_expired.send_time_minute;
      }

      if (
        this.after_expired.send_time_hour &&
        this.after_expired.send_time_minute
      ) {
        this.after_expired.send_time =
          this.after_expired.send_time_hour +
          ":" +
          this.after_expired.send_time_minute;
      }

      let send_number_info = {};

      if (this.send_number.sender_no > 0) {
        send_number_info = this.send_number;
      } else {
        send_number_info = this.send_number_items.find(
          (element) => element.sender_no === this.send_number
        );
      }

      let setParmas = {
        sender_no: send_number_info.sender_no,
        sender_number: send_number_info.sender_number,
        sms_type: this.sms_type,
        exclude_unsubscriber: this.exclude_unsubscriber,
        before_recurring_expired: this.before_recurring_expired,
        before_one_time_expired: this.before_one_time_expired,
        after_expired: this.after_expired,
        issued_point: this.issued_point,
        issued_coupon: this.issued_coupon,
        expired: this.expired,
      };

      try {
        await M.api(M.entry("/post/membership/sms"), setParmas);
        alert("저장되었습니다.");
      } catch (e) {
        //console.log(e);
      }
    },
    // SMS 알림 설정 조회
    getSendNumberItems: async function() {
      console.log("===");
      try {
        let result = await M.api(M.entry("/get/membership/sms"));
        for (let i = 0; i < result.sender_numbers.length; i++) {
          this.send_number_items.push(result.sender_numbers[i]);

          if (result.sender_number == result.sender_numbers[i].sender_number) {
            this.send_number = result.sender_numbers[i];
          }
        }

        this.exclude_unsubscriber = result.exclude_unsubscriber;
        this.sms_type = result.sms_type;
        this.byteTypeChagne();

        console.log(result);

        //멤버십 기간 만료 전 알림 (정기결제 회원 발송)
        if (!result.before_recurring_expired.message) {
          result.before_recurring_expired.message = this.expiration_befor_alarm_period;
        }
        this.before_recurring_expired = result.before_recurring_expired;

        //멤버십 기간 만료 전 알림 (정기결제 회원 발송) 시간 설정
        if (result.before_recurring_expired.send_time) {
          let before_recurring_expired_sendTime = Common.sendTimeSplit(
            result.before_recurring_expired.send_time
          );
          this.before_recurring_expired.send_time_hour =
            before_recurring_expired_sendTime[0];
          this.before_recurring_expired.send_time_minute =
            before_recurring_expired_sendTime[1];
        } else {
          this.before_recurring_expired.send_time_hour = "10";
          this.before_recurring_expired.send_time_minute = "00";
        }

        //멤버십 기간 만료 전 알림 (1회결제 회원 발송)
        if (!result.before_one_time_expired.message) {
          result.before_one_time_expired.message = this.expiration_befor_alarm_one;
        }
        this.before_one_time_expired = result.before_one_time_expired;

        //멤버십 기간 만료 전 알림 (1회결제 회원 발송) 시간 설정
        if (result.before_one_time_expired.send_time) {
          let before_one_time_expired_sendTime = Common.sendTimeSplit(
            result.before_one_time_expired.send_time
          );
          this.before_one_time_expired.send_time_hour =
            before_one_time_expired_sendTime[0];
          this.before_one_time_expired.send_time_minute =
            before_one_time_expired_sendTime[1];
        } else {
          this.before_one_time_expired.send_time_hour = "10";
          this.before_one_time_expired.send_time_minute = "00";
        }

        //멤버십 기간 만료 후 알림 (1회결제 회원 발송)
        if (!result.after_expired.message) {
          result.after_expired.message = this.expiration_after_alarm_one;
        }
        this.after_expired = result.after_expired;

        //멤버십 기간 만료 후 알림 (1회결제 회원 발송)
        if (result.after_expired.send_time) {
          let after_expired_sendTime = Common.sendTimeSplit(
            result.after_expired.send_time
          );
          this.after_expired.send_time_hour = after_expired_sendTime[0];
          this.after_expired.send_time_minute = after_expired_sendTime[1];
        } else {
          this.after_expired.send_time_hour = "10";
          this.after_expired.send_time_minute = "00";
        }

        if (!result.issued_point.message) {
          this.issued_point.message = this.point_alarm;
        } else {
          this.issued_point.message = result.issued_point.message;
        }
        this.issued_point.message_status = result.issued_point.message_status;

        if (!result.issued_coupon.message) {
          this.issued_coupon.message = this.product_buy_alarm;
        } else {
          this.issued_coupon.message = result.issued_coupon.message;
        }

        this.issued_coupon.message_status = result.issued_coupon.message_status;

        if (!result.expired.message) {
          this.expired.message = this.close_alarm;
        } else {
          this.expired.message = result.expired.message;
        }
        this.expired.message_status = result.expired.message_status;
      } catch (e) {
        //console.log(e);
      }
    },
    beforeRecurringExpiredStatus: function() {
      let status = "enabled";
      if (this.before_recurring_expired.status != "enabled") {
        status = "disabled";
      }
      this.before_recurring_expired.status = status;
    },

    beforeOneTimeExpired: function() {
      let status = "enabled";
      if (this.before_one_time_expired.status != "enabled") {
        status = "disabled";
      }
      this.before_one_time_expired.status = status;
    },

    afterExpired: function() {
      let status = "enabled";
      if (this.after_expired.status != "enabled") {
        status = "disabled";
      }
      this.after_expired.status = status;
    },

    pointMessage: function() {
      let status = "enabled";
      if (this.issued_point.message_status != "enabled") {
        status = "disabled";
      }
      this.issued_point.message_status = status;
    },
    orderedMessage: function() {
      let status = "enabled";
      if (this.issued_coupon.message_status != "enabled") {
        status = "disabled";
      }
      this.issued_coupon.message_status = status;
    },
    expiredMessage: function() {
      let status = "enabled";
      if (this.expired.status != "enabled") {
        status = "disabled";
      }
      this.expired.status = status;
    },
  },
  mixins: [CommonMixin],

  mounted: async function() {
    await this.getSendNumberItems();
    this.$parent.serchShow();
  },
};
</script>
